import PeHidden from '@pe-libs/react-components/build/components/PeHidden';
import PeTypography from '@pe-libs/react-components/build/components/PeTypography';
import React, { FC, ReactNode, memo } from 'react';
import classNames from '#utils/classNames';
import PeContentAffiliate from './PeContentAffiliate';
import useStyles from './styles';

export type Props = {
  title?: ReactNode;
  desc?: ReactNode;
  backgroundName: 'bgStairs' | 'bgFun' | 'bgPresentation' | 'bgTalk' | 'bgGroup' | 'bgCooperation' | 'bgAffiliate';
};

const PeContentLayoutMarketingBanner: FC<Props> = ({ title, desc, backgroundName }) => {
  const styles = useStyles({
    avatarUrl: '',
  });
  const {
    bgCooperation,
    bgFun,
    bgPresentation,
    bgStairs,
    bgTalk,
    bgGroup,
    gradientMask,
    sloganContainer,
    sloganTitle,
    sloganDesc,
    imageContainer,
    bgAffiliate,
    affiliateMask,
  } = styles;
  const backgrounds = { bgCooperation, bgFun, bgPresentation, bgStairs, bgTalk, bgGroup, bgAffiliate };

  const className = classNames({
    [imageContainer]: true,
    [backgrounds[backgroundName]]: true,
  });

  const isAffiliate = backgroundName === 'bgAffiliate';

  return (
    <div className={className}>
      <PeHidden smDown={true}>
        <div className={isAffiliate ? affiliateMask : gradientMask}>
          {isAffiliate && <PeContentAffiliate />}
          <div className={sloganContainer}>
            {title && (
              <PeTypography variant="h1" className={sloganTitle}>
                {title}
              </PeTypography>
            )}
            {desc && (
              <PeTypography variant="h4" className={sloganDesc}>
                {desc}
              </PeTypography>
            )}
          </div>
        </div>
      </PeHidden>
    </div>
  );
};

export default memo(PeContentLayoutMarketingBanner);
